module.exports = __webpack_public_path__ + "img/ec_public2.2d5214b3.svg";